import React from 'react';
import { useParams } from 'react-router-dom';

import { OfferUpdatePageContainer } from '@occc-app/offerHelpers/components/OfferUpdatePageContainer';
import { OfferType } from '@occc-app/offerValidationService/types';
import { useChainId } from '@occc-app/Chain/hooks';
import { BillboardConfigureFormContainer } from '@occc-app/routes/Billboard/components/BillboardConfigureForm/BillboardConfigureFormContainer';

import { messages } from '../messages';
import { getUpdatePageLinks, useGetCampaignName } from '../../CampaignComponents/utils';

export const BillboardUpdatePageContainer: React.FC = () => {
  const { id: campaignId = '', billboardId = '' } = useParams<{
    id: string;
    billboardId: string;
  }>();
  const chainId = useChainId();
  const campaignName = useGetCampaignName(chainId, campaignId);
  const getBreadcrumbLinks = (campaignComponentName: string) =>
    getUpdatePageLinks({
      campaignId,
      campaignComponentId: billboardId,
      campaignName,
      pageTitle: messages.configurePageTitle,
      campaignComponentName,
    });

  return (
    <OfferUpdatePageContainer
      campaignId={campaignId}
      offerId={billboardId}
      getBreadcrumbLinks={getBreadcrumbLinks}
      pageTitle={messages.configurePageTitle}
      subtitle={messages.subtitle}
      offerType={OfferType.Billboard}
      showExternalUrl
      ignoreConfigureFormSubmit
      ConfigureFormContainer={BillboardConfigureFormContainer}
    />
  );
};
